export enum ROUTE_PATH {
  EMPTY = '',
  HOME = '/',
  CERTIFICATES = '/certificates',
  REPORTS = '/reports',
  KNOWLEDGE_PORTAL = '/knowledge-portal',
}
